<template>

  <div id="app">
    <PasswordPage v-if="is_need_test_password"></PasswordPage>
    <HomePage v-else-if="is_act_load"></HomePage>
    <div id="app_loading" v-else></div>
  </div>

</template>

<script>
  import HomePage from './container/HomePage.vue'
  import PasswordPage from './container/PasswordPage.vue'
  import {ACT_NOT_INIT} from './constant/act_stat'
  import {PAGE_CREATE} from './constant/eventbus'
  import { user_groups_check } from "./api/index"
  import { onUseInfoLoad } from "./tools/onUseInfoLoad";
  import { compare_version } from './tools/mgtv/version'

  import './components/Popus/LoadingDialog'

  export default {
    name: 'App',
    components: {
      HomePage,
      PasswordPage
    },
    data: function () {
      return {
      }
    },
    created() {
      // window.$loading_dialog.show({})
      console.log('app created');
      setTimeout(() => {
        // 确保设备信息获取到了
        this.openTypeCheck()
      }, 1000)
      window.$bus.$emit(PAGE_CREATE);
    },
    methods: {
      openTypeCheck() {
        const open_type = gact.open_type
        switch (open_type) {
          case 'smkj':
              this.isSmkjGroup()
            break;

          default:
            break;
        }
      },
      removeLoading() {
         //去除loading
        setTimeout(()=>{
          const loading = document.querySelector('#index_loading');
          const loadingImg = document.querySelector('.loading_wrap');
          loadingImg.style.display = 'none';
            if(loading){
              loading.style.transition = `all 0.4s ease-in`
              loading.style.opacity = 0
              setTimeout(() => {
                loading.style.display = 'none';
              },400)
            }
          if(window.networkTimeout){
            window.clearTimeout(window.networkTimeout);
            window.networkTimeout = null;
          }
        },100);
      },
      isSmkjGroup() {
        // https://wiki.imgo.tv/pages/viewpage.action?pageId=36969337
        // 1. app限制  安卓大于等于6.7.8, 小于 6.8.9    ios 大于等于6.7.8, 小于 6.8.10
        // 2. 屏蔽ipad
        // 3. 屏蔽非会员用户
        // 4. 当前页面是激活状态

        if(!document.hidden && compare_version('>=' , '6.7.8') && compare_version('<' , '6.8.10') && !window.gact.is_ipad) {
            if(window.gact.is_android && compare_version('>=', '6.8.9')) {
              return
            }

            onUseInfoLoad(() => {
              if(window.$bus.user.vip_id < 1) {
                // 屏蔽非会员用户
                return
              }
              const user_group_ids_array = gact.user_group_ids && gact.user_group_ids.split(',')
              console.log('user_group_ids_array', user_group_ids_array)
              if(user_group_ids_array && user_group_ids_array.length) {
                user_groups_check(user_group_ids_array).then(res => {
                  console.log('isSmkjGroup:', res)
                  if(res && res.status == 200 && res.data) {
                    const is_target = user_group_ids_array.some(item => (!!res.data[item]))
                    if(is_target) {
                      console.log('isSmkjGroup true')
                      location.href = 'imgotv://vip-sdk?from=vip_pindao_auto'
                    } else {
                      console.log('isSmkjGroup false')
                    }
                  }
                }).catch(err => {})
              }
          })
        }

      }
    },
    computed: {
      is_need_test_password() {
        return window.$bus.is_need_test_password
      },
      is_act_load() {
        return window.$bus.act.act_stat !== ACT_NOT_INIT && window.$bus.tpl
      },
      needRemoveLoading() {
        return window.$bus.needRemoveLoading
      },
    },
    watch: {
      needRemoveLoading(val) {
        if(val){
          console.log('removeLoading')
          this.removeLoading()
        }
      }
    }
  }
</script>

<style scoped lang="stylus">

  #app {
    width: 7.5rem;
    margin: 0 auto;
    min-height: 100vh;
  }

</style>
